import "./utils/setJquery";
import "./utils/setWindowVariables";
import "./utils/setGlobalThisVariables";
import "./utils/setLogLevel";
// import "./utils/setEventBus";
import "core-ui/client/src/app/core/util/googleAnalytics/bootstrapGoogleAnalytics";
import "./Application";
import React from "react";
import { createRoot } from "react-dom/client";
import { ApplicationContainer } from "./react/components/ApplicationContainer";
import * as Sentry from "@sentry/browser";
import { Angular as AngularIntegration } from "@sentry/integrations";
import { getEnvironmentDisplayName } from "core-ui/client/react/core/utils/getEnvironmentDisplayName";
import {
    userLanguagePreference,
    pageLanguageSetting
} from "core-ui/client/react/core/utils/browserLocaleUtils";
const url = window.location.origin.toLocaleLowerCase();
const isLocalhost = url.indexOf("127.0.0.1") > -1 || url.indexOf("localhost") > -1;

if (!isLocalhost) {
    let sampleRate = window?.sentryConfig?.sampleRate;
    let tracesSampleRate = window?.sentryConfig?.tracesSampleRate;
    const sentryEnv = getEnvironmentDisplayName(window.location.host);

    if (sentryEnv !== "Production" && window.sentryConfig.lowerEnvironments) {
        sampleRate = window?.sentryConfig?.lowerEnvironments?.sampleRate;
        tracesSampleRate = window?.sentryConfig?.lowerEnvironments?.tracesSampleRate;
    }

    Sentry.init({
        dsn: "https://fa5197db62314320a0e82ed740410868@o249255.ingest.sentry.io/4505086927306752",
        integrations: [new AngularIntegration()],
        release: "login-ui@" + __applicationVersion__,
        environment: sentryEnv,
        sampleRate: sampleRate,
        tracesSampleRate: tracesSampleRate
    });

    Sentry.setTag("user_locale", userLanguagePreference());
    Sentry.setTag("page_locale", pageLanguageSetting());
}

const loadReactApp = () => {
    const container = document.getElementById("app-container");
    const root = createRoot(container);
    root.render(<ApplicationContainer />);
};

loadReactApp();
